if (!customElements.get('cart-drawer-recs')) {
  customElements.define('cart-drawer-recs', class extends HTMLElement {
    connectedCallback() {
      this._timeout = setTimeout(() => this.init(), 50);
    }

    disconnectedCallback() {
      clearTimeout(this._timeout);
    }

    init() {
      var container = this.querySelector('#cart-drawer-dynamic-recs');
      if (!container) return;

      var idsAttr = this.getAttribute('data-product-ids');
      var baseUrl = this.getAttribute('data-recommendations-url');
      var sectionId = this.getAttribute('data-section-id');
      var title = this.getAttribute('data-title') || '';

      var productIds = idsAttr ? idsAttr.split(',').filter(Boolean) : [];
      var cartIdSet = {};
      productIds.forEach(function(id) { cartIdSet[id] = true; });

      if (!productIds.length || !baseUrl) return;

      function enableInfiniteLoop(sliderEl) {
        if (!sliderEl || !sliderEl.prevButton || !sliderEl.nextButton) return;
        var prev = sliderEl.prevButton;
        var next = sliderEl.nextButton;
        var slider = sliderEl.slider;

        prev.removeAttribute('disabled');
        next.removeAttribute('disabled');
        var observer = new MutationObserver(function() {
          if (prev.hasAttribute('disabled')) prev.removeAttribute('disabled');
          if (next.hasAttribute('disabled')) next.removeAttribute('disabled');
        });
        observer.observe(prev, { attributes: true, attributeFilter: ['disabled'] });
        observer.observe(next, { attributes: true, attributeFilter: ['disabled'] });

        prev.addEventListener('click', function(e) {
          if (!sliderEl.sliderItemsToShow || sliderEl.sliderItemsToShow.length < 2) return;
          if (slider.scrollLeft <= 1) {
            e.stopImmediatePropagation();
            var lastItem = sliderEl.sliderItemsToShow[sliderEl.sliderItemsToShow.length - 1];
            slider.scrollTo({ left: lastItem.offsetLeft, behavior: 'smooth' });
          }
        }, true);

        next.addEventListener('click', function(e) {
          if (!sliderEl.sliderItemsToShow || sliderEl.sliderItemsToShow.length < 2) return;
          var maxScroll = slider.scrollWidth - slider.clientWidth;
          if (slider.scrollLeft >= maxScroll - 1) {
            e.stopImmediatePropagation();
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }, true);
      }

      function buildUrl(productId, intent) {
        return baseUrl + '?section_id=' + sectionId + '&product_id=' + productId + '&limit=8&intent=' + intent;
      }

      function extractSlides(html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var slides = [];
        temp.querySelectorAll('.complementary-slide').forEach(function(slide) {
          var prodInput = slide.querySelector('input[name="product-id"]');
          var pid = prodInput ? prodInput.value : null;
          if (pid) slides.push({ id: pid, el: slide });
        });
        return slides;
      }

      // Grab arrow SVG from the section response for reuse
      function getArrowSvg(html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var btn = temp.querySelector('.slider-button--prev .svg-wrapper');
        return btn ? btn.innerHTML : '';
      }

      function fetchRecsForProduct(productId) {
        return fetch(buildUrl(productId, 'complementary'))
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var slides = extractSlides(html);
            if (slides.length > 0) return { slides: slides, html: html };
            return fetch(buildUrl(productId, 'related'))
              .then(function(r) { return r.text(); })
              .then(function(html) { return { slides: extractSlides(html), html: html }; });
          })
          .catch(function() { return { slides: [], html: '' }; });
      }

      Promise.all(productIds.map(fetchRecsForProduct))
        .then(function(results) {
          var seen = {};
          var merged = [];
          var arrowSvg = '';

          Object.keys(cartIdSet).forEach(function(id) { seen[id] = true; });

          results.forEach(function(result) {
            if (!arrowSvg && result.html) arrowSvg = getArrowSvg(result.html);
            result.slides.forEach(function(item) {
              if (!seen[item.id]) {
                seen[item.id] = true;
                merged.push(item.el);
              }
            });
          });

          if (merged.length === 0) return;

          // Build slide HTML strings
          var slidesHtml = '';
          merged.forEach(function(slideEl, idx) {
            slideEl.id = 'Slide-cart-rec-' + (idx + 1);
            if (merged.length > 1) {
              slideEl.setAttribute('aria-label', (idx + 1) + ' of ' + merged.length);
            }
            slidesHtml += slideEl.outerHTML;
          });

          var titleHtml = title ? '<h2 class="h3 accordion__title">' + title.replace(/</g, '&lt;') + '</h2>' : '';
          var arrowsHtml = (merged.length > 1 && arrowSvg)
            ? '<div class="slider-buttons">' +
                '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left"><span class="svg-wrapper">' + arrowSvg + '</span></button>' +
                '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right"><span class="svg-wrapper">' + arrowSvg + '</span></button>' +
              '</div>'
            : '';

          // Inject as innerHTML so slider-component's constructor sees its children
          container.innerHTML =
            '<div class="complementary-products quick-add-hidden complementary-products-contains-quick-add">' +
              '<div class="complementary-products__container">' +
                '<slider-component class="slider-mobile-gutter">' +
                  '<div class="block__title">' + titleHtml + arrowsHtml + '</div>' +
                  '<div id="Slider--cart-dynamic-recs-slider" class="contains-card contains-card--product complementary-slider grid grid--1-col slider slider--everywhere" role="list"' +
                    (merged.length > 1 ? ' aria-label="Slider"' : '') + '>' +
                    slidesHtml +
                  '</div>' +
                '</slider-component>' +
              '</div>' +
            '</div>';

          // Slider-component constructor already ran with children present.
          // Just enable infinite loop after layout.
          requestAnimationFrame(function() {
            container.querySelectorAll('slider-component').forEach(function(el) {
              enableInfiniteLoop(el);
            });
          });
        });
    }
  });
}
